import Image from './_image.js'
import FlexContainerBase from './_flex-container-base.js'
import ConfigurableFlexItem from './_configurable-flex-item.js'
import ConfigurableTransition from './_configurable-transition.js'
import ConfigurableMargin from './_configurable-margin.js'

export default {
  name: 'RotatableImage',
  values: {
    image: {
      configSet: Image,
      configValues: {},
    },
    style: {
      transitionProperty: 'transform',
      transitionDuration: '0.2s',
      $mixin: [
        {
          configSet: FlexContainerBase,
        },
        {
          configSet: ConfigurableFlexItem,
        },
        {
          configSet: ConfigurableTransition,
        },
        {
          configSet: ConfigurableMargin,
        },
      ],
    },
  },
  meta: {
    extendable: false,
  },
}
